module.exports = __webpack_public_path__ + "media/assets/icons/logo_minkabu-05cb94bae34932fc3d3259f6e93fbe73.svg";